import { render, staticRenderFns } from "./waterfallChats.vue?vue&type=template&id=9b19d1b8&scoped=true"
import script from "./waterfallChats.vue?vue&type=script&lang=js"
export * from "./waterfallChats.vue?vue&type=script&lang=js"
import style0 from "./waterfallChats.vue?vue&type=style&index=0&id=9b19d1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b19d1b8",
  null
  
)

export default component.exports